import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'

const pollColors = {
  twitterPollBlue: '#22a3f3',
  twitterPollGrey: colors.n6.base,
}

export const pollStyles: CSSObject = {
  borderRadius: '15px',
  display: 'inline-flex',
  width: '100%',
  height: '28px',
  border: '1px solid rgb(34, 163, 243)',
  marginBottom: '5px',
  overflow: 'hidden',
}

export const pollTextStyles = (validOption: boolean): CSSObject => ({
  color: validOption ? pollColors.twitterPollBlue : pollColors.twitterPollGrey,
  border: 'none',
  width: '100%',
  textAlign: 'center',
  '&:focus, &:focus-visible': {
    outline: 'none',
  },
})
